import { sortDirection, SortItem, sortTypes } from '../ss-api/responses/member.dashboard.license.response';

export interface ICreditItem  {
    ID: number;
    Date: Date;
    Description: string;
    Amount: number;
}

export class CreditItem  implements ICreditItem {
    ID: number;
    Date: Date;
    Description: string;
    Amount: number;

    public static FixDates(item: CreditItem) {
        item.Date = new Date(item.Date);
    }
}


export class CreditItemArray extends Array<ICreditItem> {

    public LastSort = new SortItem;

    constructor(...items: CreditItem[]) {
        super(...items);
        Object.setPrototypeOf(this, CreditItemArray.prototype);
    }
    public static FixDates(item: CreditItemArray) {
        item.forEach(x => CreditItem.FixDates(x));
    }

    public static checkVariables(checkThis: CreditItemArray) {
        if ( checkThis.LastSort == undefined ) {
            checkThis.LastSort = new SortItem;
            checkThis.LastSort.SortType = sortTypes.ID;
            checkThis.LastSort.SortDirection = sortDirection.Unsorted;
        }
    }

    public static sortByDate( sortThis: CreditItemArray, direction: sortDirection = sortDirection.NotSpecified ): CreditItemArray {
        this.checkVariables(sortThis);
        if ( (sortThis.LastSort.SortType == sortTypes.NextBillDate && direction == sortDirection.NotSpecified && sortThis.LastSort.SortDirection == sortDirection.Ascending) || direction == sortDirection.Descending ) {
            sortThis.sort( (a, b) => {
                if (b.Date < a.Date) return -1;
                else if (b.Date > a.Date) return 1;
                else return 0;
            });
            sortThis.LastSort.SortDirection = sortDirection.Descending;
        } else {
            sortThis.sort( (a, b) => {
                if (a.Date < b.Date) return -1;
                else if (a.Date > b.Date) return 1;
                else return 0;
            });
            sortThis.LastSort.SortDirection = sortDirection.Ascending;
        }
        sortThis.LastSort.SortType = sortTypes.NextBillDate;
        return sortThis;
    }

}

